import { Button } from "@heroui/react";
import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/contexts/ThemeContext";

/** Flips between the light and dark theme. */
export const ThemeSwitch = ({ className }: { className?: string }) => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === "light";

  return (
    <Button
      isIconOnly
      aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      className={className}
      size="sm"
      variant="ghost"
      onPress={toggleTheme}
    >
      {isLight ? <Moon className="size-4" /> : <Sun className="size-4" />}
    </Button>
  );
};
